export const SUPPORTED_CURRENCIES: string[] = [
'USD', 'CNY', 'EUR', 'AED', 'ARS', 'AUD', 'BHD', 'BRL', 'CAD', 'CLP',

'CNY', 'DKK', 'GBP', 'HUF', 'IDR', 'INR', 'JPY', 'KRW', 'MXN', 'MYR',

'NOK', 'NZD', 'PHP', 'PLN', 'QAR', 'RMB', 'RON', 'RUB', 'SAR', 'SEK',

'SGD', 'SKK', 'THB', 'VEB', 'VEF', 'VND', 'ZAR'];